import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Saved from './components/Saved';
import Department from './components/Department';
import Faculty from './components/Faculty';
import FacultyLogin from './components/FacultyLogin';
import FacultyDashboard from './components/FacultyDashboard';
import StudentsDriveDetails from './components/StudentsDriveDetails';
import AddTrainers from './components/AddTrainers'; // Import AddTrainers
import LandingPage from './LandingPage'; // Import LandingPage
import LoginSection from './LoginSection'; // Import LoginSection
import TrainerLogin from './Trainers/TrainerLogin'; // Import TrainerLogin
import TrainerDashboard from './Trainers/TrainerDashboard'; // Import TrainerDashboard
import TrainersStudent from './Trainers/TrainersStudent'; // Import TrainersStudent
import TrainersTimetable from './Trainers/TrainersTimetable'; // Import TrainersTimetable
import TrainerMessage from './Trainers/TrainerMessage'; // Import TrainerMessage

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isTrainerLoggedIn, setIsTrainerLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn');
    const trainerLoggedIn = localStorage.getItem('isTrainerLoggedIn');
    setIsLoggedIn(loggedIn === 'true');
    setIsTrainerLoggedIn(trainerLoggedIn === 'true');
    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.setItem('isLoggedIn', 'false');
    setIsLoggedIn(false);
  };

  const handleTrainerLogout = () => {
    localStorage.setItem('isTrainerLoggedIn', 'false');
    setIsTrainerLoggedIn(false);
  };

  if (loading) {
    return <div>Loading...</div>; // Show a loading indicator while checking login status
  }

  return (
    <Router>
      <div className="App">
        {/* Routes */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginSection />} />
          <Route path="/facultylogin" element={<FacultyLogin setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/trainer-login" element={<TrainerLogin setIsTrainerLoggedIn={setIsTrainerLoggedIn} />} />
          <Route path="/faculty" element={isLoggedIn ? <Faculty onLogout={handleLogout} /> : <Navigate to="/" />} />
          <Route path="/trainer-dashboard" element={isTrainerLoggedIn ? <TrainerDashboard onLogout={handleTrainerLogout} /> : <Navigate to="/" />} />
          <Route path="/trainer-students" element={isTrainerLoggedIn ? <TrainersStudent /> : <Navigate to="/" />} />
          <Route path="/trainer-timetable" element={isTrainerLoggedIn ? <TrainersTimetable /> : <Navigate to="/" />} />
          <Route path="/trainer-message" element={isTrainerLoggedIn ? <TrainerMessage /> : <Navigate to="/" />} /> {/* Add route for TrainerMessage */}
          <Route path="/saved" element={isLoggedIn ? <Saved /> : <Navigate to="/" />} />
          <Route path="/departments" element={isLoggedIn ? <Department /> : <Navigate to="/" />} />
          <Route path="/dashboard" element={isLoggedIn ? <FacultyDashboard /> : <Navigate to="/" />} />
          <Route path="/students-drive-details" element={isLoggedIn ? <StudentsDriveDetails /> : <Navigate to="/" />} />
          <Route path="/add-trainers" element={isLoggedIn ? <AddTrainers /> : <Navigate to="/" />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
